import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { C } from '../../theme/palette';

export function BanniereCard({ soc, set }) {
  const b = (soc && soc.banniere) || {};
  return (
    <Card style={{ marginBottom: 12 }}>
      <Bar
        icon="📢"
        title="Message aux utilisateurs (bannière)"
        color={C.amber}
        sub="Affiche un bandeau en haut de l'app pour tous"
      />
      <div style={{ padding: 13 }}>
        <div
          style={{
            fontSize: 9,
            fontWeight: 800,
            color: C.muted,
            textTransform: 'uppercase',
            marginBottom: 6,
          }}
        >
          Type de message
        </div>
        <div style={{ display: 'flex', gap: 7, marginBottom: 11 }}>
          {[
            ['info', '📢 Info / Nouveauté'],
            ['maintenance', '⚠️ Maintenance'],
          ].map(([v, l]) => {
            const on = (b.type || 'info') === v;
            return (
              <div
                key={v}
                onClick={() => set({ banniere: { ...b, type: v } })}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  cursor: 'pointer',
                  border: '1px solid ' + (on ? C.ink : C.border),
                  borderRadius: 9,
                  padding: '9px',
                  fontSize: 10,
                  fontWeight: 800,
                  background: on ? C.navy : '#fff',
                  color: on ? '#fff' : C.grey,
                }}
              >
                {l}
              </div>
            );
          })}
        </div>
        <div
          style={{
            fontSize: 9,
            fontWeight: 800,
            color: C.muted,
            textTransform: 'uppercase',
            marginBottom: 6,
          }}
        >
          Message
        </div>
        <textarea
          value={b.texte || ''}
          onChange={(e) => set({ banniere: { ...b, texte: e.target.value } })}
          placeholder="Ex. Maintenance dimanche 2h–2h15 — service indisponible ~15 min."
          style={{
            width: '100%',
            minHeight: 60,
            border: '1px solid ' + C.border,
            borderRadius: 10,
            padding: 10,
            fontSize: 12,
            fontFamily: 'inherit',
            boxSizing: 'border-box',
            marginBottom: 11,
            outline: 'none',
          }}
        />
        <div
          onClick={() => set({ banniere: { ...b, active: !b.active } })}
          style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
        >
          <div
            style={{
              width: 44,
              height: 25,
              borderRadius: 99,
              background: b.active ? C.green : C.border,
              position: 'relative',
              flexShrink: 0,
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 2.5,
                left: b.active ? 21 : 2.5,
                width: 20,
                height: 20,
                borderRadius: 99,
                background: '#fff',
              }}
            />
          </div>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.ink }}>
            {b.active ? 'Bannière affichée ✅' : 'Bannière masquée'}
          </div>
        </div>
        <div style={{ fontSize: 8.5, color: C.muted, marginTop: 10, lineHeight: 1.5 }}>
          💡 Ce bandeau s'affiche en haut de l'app pour tous les utilisateurs de la société.
        </div>
      </div>
    </Card>
  );
}
